var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.706,
    height: 15.723,
    viewBox: "0 0 15.706 15.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp",
    transform: "translate(-68.494 -68.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218",
    transform: "translate(68.494 68.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3526",
    "data-name": "Path 3526",
    d: "M68.494,84.044l1.1-3.907a7.84,7.84,0,1,1,2.929,2.87Zm4.235-2.464.24.147a6.511,6.511,0,1,0-2.1-2.049l.162.252-.633,2.25Z",
    transform: "translate(-68.494 -68.321)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3527",
    "data-name": "Path 3527",
    d: "M149.36,152.854l-.509-.028a.615.615,0,0,0-.437.15,2.318,2.318,0,0,0-.762,1.168,3.541,3.541,0,0,0,.821,2.776,8.258,8.258,0,0,0,4.451,3.236,2.169,2.169,0,0,0,1.837-.227,1.643,1.643,0,0,0,.715-1.043l.081-.38a.264.264,0,0,0-.147-.295l-1.72-.793a.264.264,0,0,0-.319.078l-.675.875a.193.193,0,0,1-.217.065,5.288,5.288,0,0,1-2.861-2.448.2.2,0,0,1,.025-.218l.645-.747a.264.264,0,0,0,.043-.276l-.741-1.734A.264.264,0,0,0,149.36,152.854Z",
    transform: "translate(-143.7 -148.661)",
    fill: "#989898"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp2);
export default __webpack_public_path__ + "static/media/whatsapp-2.7e43dcdcb9c02300bae7dbdbfcd7044d.svg";
export { ForwardRef as ReactComponent };